import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardTitle, FormField, Input, Select } from '@invested/ui';
import * as api from '../../services/api';
import { ApiError } from '../../services/api';

export function NewParticipantPage() {
  const navigate = useNavigate();
  const [pseudonymId, setPseudonymId] = useState('');
  const [ageYears, setAgeYears] = useState('');
  const [sex, setSex] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      const participant = await api.createParticipant({
        pseudonymId: pseudonymId.trim(),
        ageYears: ageYears ? Number.parseInt(ageYears, 10) : null,
        sex: sex || null,
      });
      navigate(`/deltakere/${participant.id}`);
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : 'Kunne ikke opprette deltaker.');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="max-w-xl space-y-6">
      <CardTitle as="h1">Ny deltaker</CardTitle>
      <Card size="lg">
        <form onSubmit={submit} className="space-y-5">
          <FormField label="Pseudonym-ID" htmlFor="pseudonymId" required hint="Format DNAM-NNN, f.eks. DNAM-007">
            <Input
              id="pseudonymId"
              required
              pattern="DNAM-\d{3}"
              placeholder="DNAM-001"
              value={pseudonymId}
              onChange={(e) => setPseudonymId(e.target.value.toUpperCase())}
            />
          </FormField>
          <FormField label="Alder ved inklusjon (år)" htmlFor="ageYears" optional>
            <Input
              id="ageYears"
              type="number"
              min={0}
              max={120}
              value={ageYears}
              onChange={(e) => setAgeYears(e.target.value)}
            />
          </FormField>
          <FormField label="Kjønn" htmlFor="sex" optional>
            <Select
              id="sex"
              value={sex}
              onChange={(e) => setSex(e.target.value)}
              placeholder="Ikke oppgitt"
              options={[
                { value: 'FEMALE', label: 'Kvinne' },
                { value: 'MALE', label: 'Mann' },
              ]}
            />
          </FormField>
          {error && (
            <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
              {error}
            </p>
          )}
          <Button type="submit" disabled={pending}>
            {pending ? 'Oppretter…' : 'Opprett deltaker'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
